import React from "react";
import { Typography, Grid } from "@mui/material";
import DataField from "../Datafield";
import MappedText from "../../reports/create-report/shared-components/mapText";





export default function PatientInfo({ allDataApis }) {
    return (
      <>
        <Typography variant={"h5"} style={{ fontWeight: "700", marginBottom: "20px" }}>
          <MappedText text={"Patient Info"} />
        </Typography>
        <Grid container spacing={2} sx={{ marginBottom: 4 }}>
          <Grid item xs={12} sm={6} md={3}>
            <DataField
              title="Patient ID"
              value={allDataApis?.participants?.[0].report_id || "NA"}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <DataField
              title="Sex"
              value={allDataApis?.participants?.[0].sex || "NA"}
            />
          </Grid>
        </Grid>
      </>
    );
  }